import { ReactNode } from 'react';
import { Button } from '..';

interface StepContainerProps {
  title: string;
  description?: string;
  children: ReactNode;
  onNext?: () => void;
  onBack?: () => void;
  nextLabel?: string;
  backLabel?: string;
  isLoading?: boolean;
  showSkip?: boolean;
  onSkip?: () => void;
  skipLabel?: string;
}

export default function StepContainer({
  title,
  description,
  children,
  onNext,
  onBack,
  nextLabel = 'Volgende',
  backLabel = 'Vorige',
  isLoading = false,
  showSkip = false,
  onSkip,
  skipLabel = 'Overslaan',
}: StepContainerProps) {
  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="card">
        {/* Header */}
        <div className="mb-8 text-center">
          <h2 className="text-3xl font-bold mb-2 dark:text-gray-100">
            {title}
          </h2>
          {description && (
            <p className="text-lg text-gray-600 dark:text-gray-400">
              {description}
            </p>
          )}
        </div>

        {/* Content */}
        <div className="mb-8">{children}</div>

        {/* Navigation */}
        <div className="flex items-center justify-between gap-4">
          <div>
            {onBack && (
              <Button
                variant="secondary"
                onClick={onBack}
                disabled={isLoading}
              >
                {backLabel}
              </Button>
            )}
          </div>

          <div className="flex items-center gap-4">
            {showSkip && onSkip && (
              <Button
                variant="secondary"
                onClick={onSkip}
                disabled={isLoading}
              >
                {skipLabel}
              </Button>
            )}
            {onNext && (
              <Button
                variant="primary"
                onClick={onNext}
                isLoading={isLoading}
              >
                {nextLabel}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
